<app-modal-form
  [isOpen]="true"
  [formId]="'addUserForm'"
  (closeModal)="cancelar()"
  [mainLabel]="'Guardar'"
  [mainIcon]="'save'"
  [mainDisabled]="form.invalid || (!!initialData && !hasChanges)"
  [cancelLabel]="'Cancelar'"
  [loading]="isLoading"
  [cancelIcon]="'cancel'"
  (mainAction)="onSubmit()"
  (cancelAction)="cancelar()"
>
  @if (form) {
    <form
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      [class.form-ready]="isModalReady"
      id="addUserForm"
      class="form-layout"
    >
      <div class="form-layout__header">
        <app-form-title
          [main]="initialData ? 'Editar' : 'Crear'"
          [sub]="initialData ? 'usuario' : 'nuevo usuario'"
        ></app-form-title>
      </div>

      <div
        class="grid grid-cols-1 sm:grid-cols-2 gap-x-20 gap-y-[12px] sm:gap-y-6"
      >
        <div class="w-full">
          <app-form-input
            label="Nombre"
            rounded="true"
            for="firstName"
            type="text"
            [placeholder]="
              initialData && !firstNameControl.value ? 'N/A' : 'Placeholder'
            "
            [control]="firstNameControl"
            tooltipText="Ingrese el nombre del usuario."
            [showHelpIcon]="true"
          ></app-form-input>
        </div>

        <div class="w-full">
          <app-form-input
            label="Direccion"
            for="address"
            type="text"
            [placeholder]="
              initialData && !addressControl.value ? 'N/A' : 'Placeholder'
            "
            [control]="addressControl"
            tooltipText="Ingrese la dirección completa del usuario."
            [showHelpIcon]="true"
          ></app-form-input>
        </div>

        <div class="w-full">
          <app-form-input
            label="Apellido"
            for="lastName"
            type="text"
            [placeholder]="
              initialData && !lastNameControl.value ? 'N/A' : 'Placeholder'
            "
            [control]="lastNameControl"
            tooltipText="Ingrese el apellido del usuario."
            [showHelpIcon]="true"
          ></app-form-input>
        </div>

        <div class="w-full">
          <app-date-range-picker
            label="Fecha"
            [placeholder]="
              initialData && !birthdateControl.value ? 'N/A' : 'DD/MM/AAAA'
            "
            [control]="birthdateControl"
            [required]="true"
            help="Seleccione la fecha de nacimiento."
            [errorMessages]="getErrorMessage('birthdate')"
          ></app-date-range-picker>
        </div>

        <div class="w-full">
          <label
            for="phone"
            class="flex items-center gap-1 text-white text-[14px] font-medium"
          >
            Telefono
            <span
              class="relative inline-flex items-center cursor-pointer group"
            >
              <mat-icon
                class="text-blue-500 text-[15px] group-hover:scale-110 transition-transform"
              >
                help_outline
              </mat-icon>
              <span
                class="absolute left-0 top-[120%] z-10 w-[230px] bg-gray-800 text-white text-left rounded-md px-3 py-2 text-xs opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-300"
              >
                Ingrese el número de teléfono.
                <span
                  class="absolute -top-2 left-2 w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-b-8 border-b-gray-800"
                ></span>
              </span>
            </span>
          </label>

          <div class="flex gap-2">
            <div
              class="flex items-center justify-center h-[30px] sm:h-[38px] px-3 bg-[#232326] border border-[#bebebe] rounded-l-[16px] text-white text-[15px]"
            >
              +57
            </div>
            <input
              id="phone"
              type="text"
              [placeholder]="
                initialData && !phoneControl.value ? 'N/A' : 'Placeholder'
              "
              [formControl]="phoneControl"
              (keydown)="isNumberKey($event)"
              class="flex-1 h-[30px] sm:h-[38px] px-3 bg-[#232326] border border-[#bebebe] rounded-r-[16px] text-white text-[15px] focus:outline-none"
            />
          </div>

          @if (phoneControl.touched && phoneControl.invalid) {
            <div class="text-xs text-gray-500 mt-1">
              {{ getErrorMessage("phone") }}
            </div>
          }
        </div>

        <div class="w-full">
          <app-form-input
            label="Correo"
            for="email"
            type="email"
            [placeholder]="
              initialData && !emailControl.value ? 'N/A' : 'Placeholder'
            "
            [control]="emailControl"
            tooltipText="Ingrese un correo electrónico válido."
            [showHelpIcon]="true"
          ></app-form-input>
        </div>
      </div>
    </form>
  }
</app-modal-form>
